import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import MapView from "@/components/MapView";
import { Bus, Clock, MapPin } from "lucide-react";

export default function BusRoutes() {
  const [items, setItems] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    api.get("/bus-routes").then((r) => {
      setItems(r.data || []);
      setActive(r.data?.[0]);
    });
  }, []);

  return (
    <div className="grid grid-cols-12 gap-4">
      <div className="col-span-12 lg:col-span-5">
        <div className="flex items-end justify-between mb-4">
          <div>
            <p className="text-[11px] uppercase tracking-widest text-slate-400 font-bold">Schedule</p>
            <h1 className="font-display font-bold text-2xl text-slate-900">Bus Routes</h1>
          </div>
        </div>

        <div className="space-y-2">
          {items.map(r => (
            <button
              key={r.id}
              data-testid={`route-${r.id}`}
              onClick={() => setActive(r)}
              className={`w-full text-left p-4 rounded-2xl border-2 transition-all ${active?.id === r.id ? "border-primary bg-primary-50/40" : "border-slate-100 bg-white hover:border-slate-200"}`}
            >
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-xl bg-primary text-white flex items-center justify-center">
                  <Bus size={22} />
                </div>
                <div className="flex-1">
                  <p className="font-display font-bold text-slate-900">{r.name}</p>
                  <p className="text-xs text-slate-500 font-ar">{r.name_ar}</p>
                </div>
                <div className="text-right">
                  <p className="font-mono text-sm font-bold text-slate-900">{r.departure_time}</p>
                  <p className="text-[10px] text-slate-400 font-bold uppercase tracking-wider">{r.booked_seats || 0}/{r.vehicle?.capacity || 0} booked</p>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>

      {active && (
        <div className="col-span-12 lg:col-span-7 bg-white rounded-2xl border border-slate-200 overflow-hidden flex flex-col">
          <div className="px-5 py-4 border-b border-slate-100">
            <p className="font-display font-bold text-xl">{active.name}</p>
            <p className="text-sm text-slate-500">{active.vehicle?.make} {active.vehicle?.model} · {active.vehicle?.plate_number}</p>
          </div>
          <div className="h-64">
            <MapView
              pickup={{ lat: active.departure_lat, lng: active.departure_lng }}
              dropoff={{ lat: active.arrival_lat, lng: active.arrival_lng }}
              route={[[active.departure_lat, active.departure_lng], [active.arrival_lat, active.arrival_lng]]}
              center={[(active.departure_lat + active.arrival_lat) / 2, (active.departure_lng + active.arrival_lng) / 2]}
              zoom={8}
            />
          </div>
          <div className="p-5 space-y-3">
            <div className="grid grid-cols-2 gap-3">
              <div className="p-3 rounded-xl bg-slate-50">
                <p className="text-[10px] uppercase tracking-wider text-slate-400 font-bold flex items-center gap-1"><Clock size={11} /> Departure</p>
                <p className="font-display font-bold text-lg">{active.departure_time}</p>
                <p className="text-xs text-slate-500 truncate">{active.departure_address}</p>
              </div>
              <div className="p-3 rounded-xl bg-slate-50">
                <p className="text-[10px] uppercase tracking-wider text-slate-400 font-bold flex items-center gap-1"><MapPin size={11} /> Arrival</p>
                <p className="font-display font-bold text-lg">{active.arrival_time}</p>
                <p className="text-xs text-slate-500 truncate">{active.arrival_address}</p>
              </div>
            </div>
            <div className="text-xs text-slate-500">
              Days: <span className="font-bold text-slate-900">{active.days_of_week?.join(", ")}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
